import React from "react"
import PropTypes from "prop-types"
import {CardElement, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement} from '@stripe/react-stripe-js';
import StandardButton from '../../app_components/StandardButton';

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#c4f0ff',
      color: '#fff',
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {color: '#fce883'},
      '::placeholder': {color: '#87bbfd'},
    },
    invalid: {
      iconColor: '#ffc7ee',
      color: '#ffc7ee',
    },
  },
};


const CreditCardElement = (props) => {

  const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
      // Block native form submission.
      event.preventDefault();

      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }

      // Get a reference to a mounted CardElement. Elements knows how
      // to find your CardElement because there can only ever be one of
      // each type of element.

      const cardNumberElement = elements.getElement(CardNumberElement);

      // Use your card Element with other Stripe.js APIs
      const {error, paymentMethod} = await stripe.createPaymentMethod({
        type: 'card',
        card: cardNumberElement,
      });

      if (error) {
        props.setError(error.message)
      } else {
        props.processingPayment(paymentMethod.id)
      }
    };

    return (
      <form onSubmit={handleSubmit}>
          <fieldset className="FormGroup">
            <div className="FormRow">
              <CardNumberElement/>
            </div>
          </fieldset>
          <fieldset className="FormGroup">
            <div className="FormRow" style={{width: '45%', display: 'inline-block', float: 'left'}}>
              <CardExpiryElement/>
            </div>
            <div className="FormRow" style={{width: '45%', display: 'inline-block', float: 'right'}}>
              <CardCvcElement/>
            </div>
          </fieldset>
        <div className="sectionDivider"></div>

        <div style={{padding: 10}}>
          <h5 style={{textAlign: 'left', marginBottom: 20, marginTop: 20}} className="darkBlue thinText">Total</h5>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20}}>
            <h5 className="thinText" style={{color: '#A3A3A4'}}>{props.description}</h5>
            <h4 className="darkBlue" style={{fontWeight: 500}}>${props.total}</h4>
          </div>
        </div>


        <div style={{display: 'flex', justifyContent: 'flex-end', padding: 10}}>
          {props.isProcessingPayment &&
            <div style={{width: 200}}>
              <StandardButton loading={true} primary={true} size="large"/>
            </div>}
          {!props.isProcessingPayment &&
            <button type="submit" disabled={!stripe} className="button_primary" >
              {`Pay $${props.total}`}
            </button>}
        </div>
        <div className="powered_by_stripe"></div>
      </form>
    );
};

export default CreditCardElement;
